<template>
    <div>
        <header>
            <v-container>
                <v-row no-gutters>
                    <h1 class="font-weight-light headline">
                        {{ $t("title.language") }}
                    </h1>
                    <v-spacer></v-spacer>
                    <v-lazy v-if="isLanguagesLoaded" transition="fade-transition">
                        <v-text-field v-model="search" append-icon="mdi-magnify" :label="searchLabel" single-line dense
                            hide-details style="max-width: 200px" class="mr-5 pr-5"></v-text-field>
                    </v-lazy>
                    <v-lazy transition="fade-transition">
                        <v-btn color="success" dark small @click.stop="
                            dialog.languageForm = true;
                        isLanguageEdited = false;
                        ">{{ $t("general.add") }}</v-btn>
                    </v-lazy>
                </v-row>
            </v-container>
        </header>
        <section class="py-7">
            <v-container>
                <v-sheet class="px-3 pt-3 pb-3" v-if="!isLanguagesLoaded">
                    <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
                </v-sheet>
                <v-card v-else>
                    <v-data-table :headers="headers" :items="languages" :search="search">
                        <template v-slot:item.action="{ item }">
                            <div style="display: flex">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-tr-class-on-hover="'blue'" size="20px" color="blue" class="mr-2"
                                            @click="editLanguage(item)" v-on="on">mdi-pencil-outline</v-icon>
                                    </template>
                                    <span>{{ $t("general.edit") }}</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon  v-if="item.code !== 'cz'" size="22px" color="red" v-tr-class-on-hover="'red'" class="mr-2"
                                            @click="confirmDelete(item)" v-on="on">mdi-delete-outline</v-icon>
                                    </template>
                                    <span>{{ $t("general.delete") }}</span>
                                </v-tooltip>
                            </div>
                        </template>

                        <template v-slot:item.code="{ item }">
                            <div class="d-flex align-center">
                                <v-icon small class="mr-2">fi fi-{{ item.code }}</v-icon>
                            </div>
                        </template>

                        <template v-slot:item.is_active="{ item }">
                            <v-switch v-if="item.code !== 'cz'" class="mt-0 pt-0 justify-content-center" hide-details color="green"
                                v-model="item.is_active" @change="changeStatus(item)"></v-switch>
                        </template>
                    </v-data-table>
                </v-card>
                <LanguageForm :language="selectedLanguage" :visible="dialog.languageForm" :isEdited="isLanguageEdited"
                    @addLanguage="addLanguage" @updateLanguage="updateLanguage" @close="dialog.languageForm = false"
                    @snackMessage="snackMessage" />

                <ConfirmationDialog :name="selectedLanguage.language" :text="'languages.delete_confirmation'"
                    v-if="dialog.confirmation" @confirm="deleteLanguage" @cancel="cancelDelete" />

                <SnackMessage ref="SnackMessage" />
            </v-container>
        </section>
    </div>
</template>

<script>
import LanguageForm from "../components/LanguageForm";
import ConfirmationDialog from "../components/ConfirmationDialog";
import SnackMessage from "../components/SnackMessage";
import countries from "../data/countries";
export default {
    data() {
        return {
            countries: countries,
            languages: [],
            isLanguagesLoaded: false,
            search: "",
            dialog: {
                confirmation: false,
                languageForm: false,
            },
            language: {
                name: null,
                country: null,
                code: null,

            },
            selectedLanguage: {
                name: null,
                country: null,
                code: null,

            },
            defaultLanguage: {
                name: null,
                country: null,
                code: null,

            },
            isLanguageEdited: false,
        };
    },

    components: {
        LanguageForm,
        ConfirmationDialog,
        SnackMessage,
    },

    computed: {
        headers() {
            return [
                {
                    text: this.$t("general.actions"),
                    value: "action",
                    sortable: false,
                },
                {
                    text: this.$t("languages.language"),
                    align: "left",
                    sortable: false,
                    value: "name",
                },
                {
                    text: this.$t("languages.country"),
                    align: "left",
                    sortable: false,
                    value: "code",
                },
                {
                    text: this.$t("general.active"),
                    align: "left",
                    sortable: false,
                    value: "is_active",
                },
            ];
        },
        searchLabel() {
            return this.$t("general.search");
        },
    },

    created() {
        this.getLanguages();
    },

    methods: {
        snackMessage(msg, type) {
            this.$refs.SnackMessage.showMessage(msg, type);
        },
        async getLanguages() {
            await axios
                .get("/languages", {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.user.access_token,
                    },
                })
                .then((response) => {
                    this.languages = response.data;
                    this.isLanguagesLoaded = true;
                })
                .catch((error) => {
                    console.log(error.response.data);
                });
        },
        addLanguage(language) {
            this.languages.push(language);
            this.getLanguages();
        },
        editLanguage(item) {
            this.selectedLanguage = Object.assign({}, item);
            this.dialog.languageForm = true;
            this.isLanguageEdited = true;
        },
        updateLanguage(language) {
            let index = this.languages.findIndex((item) => item.id == language.id);
            this.languages.splice(index, 1, language);
            this.getLanguages();
        },
        confirmDelete(item) {
            this.selectedLanguage = item;
            this.dialog.confirmation = true;
        },
        cancelDelete() {
            this.dialog.confirmation = false;
        },
        async deleteLanguage() {
            this.dialog.confirmation = false;
            let index = this.languages.indexOf(this.selectedLanguage);

            await axios
                .delete(`/languages/${this.selectedLanguage.id}`, {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.user.access_token,
                    },
                })
                .then((response) => {
                    this.selectedLanguage = this.defaultLanguage;
                    this.languages.splice(index, 1);

                    this.$refs.SnackMessage.showMessage(
                        "languages.deleted_successfully",
                        "success"
                    );
                })
                .catch((error) => {
                    console.log(error);
                    this.$refs.SnackMessage.showMessage(
                        "general.error",
                        "error"
                    );
                });
        },
        async changeStatus(item) {
            try {
                const request = await axios.put(
                    "/languages/status/" + item.id,
                    item,
                    {
                        headers: {
                            Authorization:
                                "Bearer " +
                                this.$store.state.tokenData.user.access_token,
                        },
                    }
                );
                this.getLanguages();
                this.snackMessage("general.item_saved", "success");
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>